import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import clientConfig from 'universal-config';
var fbScriptRendered = false;
var FB_SDK_JS = "(function(d, s, id){\n    var js, fjs = d.getElementsByTagName(s)[0];\n    if (d.getElementById(id)) {return;}\n    js = d.createElement(s); js.id = id;\n    js.src = \"//connect.facebook.net/en_US/sdk.js\";\n    fjs.parentNode.insertBefore(js, fjs);\n}(document, 'script', 'facebook-jssdk'));";
export var FacebookSDK =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FacebookSDK, _React$Component);

  function FacebookSDK() {
    _classCallCheck(this, FacebookSDK);

    return _possibleConstructorReturn(this, _getPrototypeOf(FacebookSDK).apply(this, arguments));
  }

  _createClass(FacebookSDK, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (fbScriptRendered && !__TEST__) {
        return;
      }

      fbScriptRendered = true;
      var config = clientConfig();
      var sdkInitJs = "window.fbAsyncInit = function() {\n      FB.init({\n        appId: ".concat(config && config.fb && config.fb.appId, ",\n        xfbml : true,\n        version : 'v2.10'\n      });\n\n      FB.getLoginStatus(function (response) {\n        window._fbAuthResponse = response;\n\n        var event = document.createEvent('Event');\n        event.initEvent('facebookReady', true, true);\n        document.body.dispatchEvent(event);\n      });\n    };");
      var script = document.createElement('script');
      script.textContent = FB_SDK_JS + sdkInitJs;
      script.id = 'fb-js-root';
      document.body.appendChild(script);
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);

  return FacebookSDK;
}(React.Component);